<template>
    <span :class="klass">{{text}}</span>
</template>

<script>

const colors = {
    0: "warning",
    1: "success",
    2: "danger",
    3: "secondary",
    4: "primary"
}

const text = {
    0: "En espera",
    1: "Activo",
    2: "Cancelado",
    3: "Eliminado",
    4: "Pausado"
}

export default {
    name: "BadgeState",
    props:{
        state: {
            type: Number,
            defualt: 0
        }
    },
    computed: {
        klass: function(){
            return "badge mr-1 badge-"+colors[this.state];
        },
        text: function(){
            return text[this.state]
        }
    }
}
</script>